import React, { createRef } from 'react';
import Dropzone from 'react-dropzone';
import message from 'antd/lib/message';

const dropzoneRef = createRef();

export default class SelectFile extends React.Component {
  static defaultProps = {
    onFileChange: () => {},
    onChange: () => {},
    disabled: false,
    name: null,
    type: '*',
    'data-__field': { name: '' },
    mountComponent: () => (
      <p>Drag 'n' drop a file here, or click to select a file</p>
    ),
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      size: 0,
      type: '',
    };
  }

  onDrop = ([file = null]) => {
    let { onFileChange, onChange, name, disabled } = this.props;

    if (!disabled) {
      if (file) {
        const reader = new FileReader();

        reader.onabort = () => message.error('Read file aborted!');
        reader.onerror = () => message.error('Failed to read file!');
        reader.onload = () => {
          let theName = name || file.name;
          this.setState({ name: theName, type: file.type, size: file.size });
          let result = reader.result;
          onFileChange({
            name: theName,
            type: file.type,
            size: file.size,
            value: result,
          });
          onChange({
            target: {
              value: result,
              name: this.props['data-__field'].name,
            },
          });
        };
        reader.readAsDataURL(file);
      } else {
        message.error('Invalid file selected!');
      }
    }
  };
  render = () => {
    let { type, mountComponent, onChange, disabled, ...theRest } = this.props;
    let { name, type: imageType, size } = this.state;

    return (
      <Dropzone
        ref={dropzoneRef}
        onDrop={this.onDrop}
        {...(['*', null, undefined, ''].includes(type) ? {} : { accept: type })}
        multiple={false}
        disabled={disabled}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {mountComponent({ name, type: imageType, size }, theRest)}
          </div>
        )}
      </Dropzone>
    );
  };
}
